//////////////////////////////////////////////////////
/// DO NOT EDIT                                    ///
/// Generated by Trygghetsfonden.Dataverse.Tools   ///
/// Source file: xrm.context.include.txt           ///
//////////////////////////////////////////////////////

export enum tsl_projektdeltagande_tsl_intresseradavstod {
	Tackatja = 1,
	Ejintresserad = 2,
	Villavvakta = 5,
	Ejgttattn = 7,
	Redantillsvidareanstlldpheltid = 8,
};
